import { useRef } from 'react';
import { c as classNames } from './bind-f8092ad0.js';
import { jsx } from 'react/jsx-runtime';
import useMouseDrag from '../hooks/useDrag/useMouseDrag.js';

var styles = {
  "unit-base": "4",
  "bottom-sheet-animation-speed": "400",
  "overlay": "web_ui__BottomSheet__overlay",
  "bottom-sheet": "web_ui__BottomSheet__bottom-sheet",
  "container": "web_ui__BottomSheet__container",
  "portal": "web_ui__BottomSheet__portal",
  "after-open": "web_ui__BottomSheet__after-open",
  "before-close": "web_ui__BottomSheet__before-close",
  "wrapper": "web_ui__BottomSheet__wrapper",
  "handle-container": "web_ui__BottomSheet__handle-container",
  "dragging": "web_ui__BottomSheet__dragging",
  "handle": "web_ui__BottomSheet__handle",
  "content": "web_ui__BottomSheet__content",
  "modal-open": "web_ui__BottomSheet__modal-open"
};

var cssClasses = classNames.bind(styles);
var Handle = function Handle(_ref) {
  var onDrag = _ref.onDrag;
  var handlerRef = useRef(null);
  var isDragging = useMouseDrag(handlerRef, onDrag);
  return /*#__PURE__*/jsx("div", {
    className: cssClasses('handle-container', {
      dragging: isDragging
    }),
    ref: handlerRef,
    children: /*#__PURE__*/jsx("div", {
      className: cssClasses('handle')
    })
  });
};

export { Handle as H, styles as s };
//# sourceMappingURL=Handle-e8033c65.js.map
